// Import necessary modules
import { setBathwareProductDetailsData } from "@/store/bathware_slices/bathware_product_details_slice";
import { fetchData, SITE_URL } from "@/utils/api";
import { commonData } from "@/utils/commonData";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { parseCookies } from "nookies";
import dynamic from "next/dynamic";
import SeoHead from "@/components/ui/seoHead/seoHead";
import Head from "next/head";
import { generateBreadcrumbSchema } from "@/utils/constants";

// Dynamically import the Bathware Details Page
const Bathware_Details_Page = dynamic(
  () => import("@/components/bathware_pages/bathware-details-page"),
  { ssr: true }
);

export const getServerSideProps = commonData(async (context) => {
  try {
    // Extract query parameters and resolve URL
    const queryParams = context.query;
    const resolvedUrl = context.resolvedUrl;
    const cleanResolvedUrl = resolvedUrl.startsWith("/")
      ? resolvedUrl.substring(1)
      : resolvedUrl;

    // Construct query string
    const queryString = Object.entries(queryParams)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    const endpoint = `bathware/product_details?${queryString}&user_id=${null}`;
    const result = await fetchData(endpoint);
    // Construct full URL for the bathware product details page
    const bathwareProductDetailsUrl = SITE_URL.concat(cleanResolvedUrl);
    if (!result || !result?.data) {
      return { notFound: true };
    }
    return {
      props: {
        queryString,
        bathwareProductDetailsUrl,
        productData: result?.data,
        currentUrl: resolvedUrl,
      },
    };
  } catch (error) {
    console.error("Error in getServerSideProps:", error);
    return { notFound: true };
  }
});

const Bathware_Product_Details = ({
  queryString,
  bathwareProductDetailsUrl,
  productData,
  currentUrl,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [user, setUser] = useState(null);
  // Fetch user data from cookies

  useEffect(() => {
    const cookies = parseCookies();
    const user = JSON.parse(cookies.user || null);
    setUser(user);
  }, []);

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        let userId = null;
        if (user && user.id) {
          userId = user.id;
        }

        // const endpoint = `bathware/product_details?${queryString}&user_id=${userId}`;
        // const result = await fetchData(endpoint);
        setData(productData);
        dispatch(setBathwareProductDetailsData(productData));
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };
    fetchProductData();
  }, [queryString, dispatch, user, productData]);

  useEffect(() => {
    if (data?.meta_title) {
      document.title = data.meta_title;
    }
  }, [data?.meta_title]);

  const breadcrumbData = [
    {
      title: "Bathware",
      link: "/bathware",
    },
    {
      title: productData?.product_name,
    },
  ];
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateBreadcrumbSchema(breadcrumbData, currentUrl)
            ),
          }}
        />
      </Head>
      {productData && (
        <SeoHead
          meta_title={productData?.meta_title}
          meta_description={productData?.meta_description}
        />
      )}
      {productData && (
        <Bathware_Details_Page
          bathwareProductDetailsUrl={bathwareProductDetailsUrl}
          bathwareProductDetailsApiData={productData}
        />
      )}
    </>
  );
};

export default Bathware_Product_Details;
